import React, { type FC, type PropsWithChildren } from 'react';

import reactHTMLParser from '../../utils/reactHTMLParser';
import Box from '../box/box';
import Heading from '../heading/heading';
import type { Lucid } from '../../types/types';

interface FeaturedSnippetProps {
  item: Lucid.Directus.Generated.Blog_Featured_Snippet;
}

const FeaturedSnippet: FC<PropsWithChildren<FeaturedSnippetProps>> = ({ item }) => (
  <Box
    key={item.id}
    as="section"
    css={theme => ({
      label: 'blogFeaturedSnippet',
      backgroundColor: theme.colors.coolGrey[5],
      padding: theme.space.s24,
    })}
  >
    <Heading as="h2" variant="headingM">
      {item.heading}
    </Heading>
    <Box css={theme => [theme.shared.blogStyles(theme), theme.shared.htmlParserStyles(theme)]}>
      {reactHTMLParser(item.html)}
    </Box>
  </Box>
);

export default FeaturedSnippet;
